(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      window.addEventListener('load', () => {
        this.setAnnouncementHeight();
        window.addEventListener('change', this.setAnnouncementHeight.bind(this));
      });
    }

    setAnnouncementHeight() {
      document.documentElement.style.setProperty('--announcement-height', `${this.offsetHeight}px`);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      window.addEventListener('load', () => {
        this.setHeaderHeight();
        window.addEventListener('change', this.setHeaderHeight.bind(this));
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${
        this.offsetHeight
      }px`);
    }
  }

  customElements.define('header-bar', HeaderBar);

  } catch(e) { console.error(e); }
})();
})();
